import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _UsersAltLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { cx: 9, cy: 8, r: 3.5, stroke: "currentColor", strokeLinecap: "round" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M1.85 16.948c.639-2.345 3.065-3.448 5.495-3.448h3.31c2.43 0 4.856 1.103 5.496 3.448a10 10 0 0 1 .295 1.553c.06.55-.394.999-.946.999h-13c-.552 0-1.005-.45-.946-.998a10 10 0 0 1 .295-1.554ZM18.5 19.5h3c.552 0 1.005-.45.946-.998a10 10 0 0 0-.295-1.554c-.64-2.345-3.066-3.448-5.496-3.448H16M14 5.296c.366-.19.777-.296 1.21-.296C16.751 5 18 6.343 18 8s-1.249 3-2.79 3c-.433 0-.844-.106-1.21-.296" })));
}
const UsersAltLight = forwardRef(_UsersAltLight);
export { UsersAltLight };
